export default "__VITE_ASSET__sM90Bh1z__"